import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BACKEND_URL } from '../app.config';

import { ListResult, ProcessModule } from '../api/data-model';
import { Milestone, Phase } from '../api/process-module/process-module';

@Injectable()
export class ProcessModuleService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  getList(sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<ProcessModule>> {
    return this.http.get<ListResult<ProcessModule>>(this.baseUrl + '/api/app/process-module', {
      params: {
        sorting,
        skipCount,
        maxResultCount,
      },
    });
  }

  getProcessModule(id: string): Observable<ProcessModule> {
    return this.http.get<ProcessModule>(this.baseUrl + '/api/app/process-module/' + id);
  }

  createProcessModule(input: ProcessModule): Observable<ProcessModule> {
    return this.http.post<ProcessModule>(this.baseUrl + '/api/app/process-module', input);
  }
  updateProcessModule(id: string, input: ProcessModule): Observable<ProcessModule> {
    return this.http.put<ProcessModule>(this.baseUrl + '/api/app/process-module/' + id, input);
  }

  getAllMilestones(): Observable<Milestone[]> {
    return this.http.get<Milestone[]>(`${this.baseUrl}/api/app/process-module/milestones`);
  }

  getMilestonesByVersionId(versionId: string): Observable<Milestone[]> {
    return this.http.get<Milestone[]>(`${this.baseUrl}/api/app/process-module/versions/${versionId}/milestones`);
  }

  getPhasesByVersionId(versionId: string): Observable<Phase[]> {
    return this.http.get<Phase[]>(`${this.baseUrl}/api/app/process-module/versions/${versionId}/phases`);
  }
}
